<template>
    <div class="custom-work-options">
        <CustomWorkOption
            v-for="option in packages"
            :key="option.key"
            :option="option"
            @packageSelected="packageSelected(option)"
        />
    </div>
</template>
<script>
import CustomWorkOption from './CustomWorkOption.vue'

export default {
    components: {
        CustomWorkOption,
    },
    props: {
        packages: {
            type: Array,
            required: true,
        },
    },
    methods: {
        packageSelected(option) {
            this.$emit('packageSelected', option)
        },
    },
}
</script>
<style>
.custom-work-options {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(auto-fit, minmax(240px, auto));
    justify-content: stretch;

    & > :nth-child(2) {
        border: 1px solid var(--color-link);
    }
}
</style>
